// import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ficha_cpf: '',
    ficha_id_categoria: null,
    cupom: '',
    isencao: '',
    valor_isencao: 0,
    user: null,
    valor_total: 0
  },
  mutations: {
    setCPF (state, cpf) {
      state.ficha_cpf = cpf
    },
    setID_Categoria (state, idcategoria) {
      state.ficha_id_categoria = idcategoria
    },
    setCupom (state, cupom) {
      state.cupom = cupom
    },
    setIsencao (state, isencao) {
      state.isencao = isencao
    },
    setValorIsencao (state, valorisencao) {
      state.valor_isencao = valorisencao
    },
    setUser (state, user) {
      state.user = user
      // if (user) {
      //   axios.defaults.headers.common['Authorization'] = `bearer ${user.token}`
      //   state.layout = 'Restrito'
      // } else {
      //   delete axios.defaults.headers.common['Authorization']
      //   state.layout = 'Publico'
      // }
    },
    setValorTotal (state, valortotal) {
      state.valor_total = valortotal
    }
  },
  actions: {
  },
  modules: {
  }
})
